const baseURL = process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:8080/' : 'https://app.hy-chip.com/'
// const baseURL = process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:8080/' : 'https://192.168.0.191/'
export default {
  baseURL
}



// WEBPACK FOOTER //
// ./src/api/global.js